import React, { useEffect } from 'react';
import { useStyletron } from 'baseui';
import { useSetAtom } from 'jotai';
import { currentThemeAtom } from './theme-atoms';
export const ThemeSyncer = () => {
  const [, theme] = useStyletron();
  const setTheme = useSetAtom(currentThemeAtom);
  useEffect(() => {
    if (theme.name.startsWith('light')) {
      setTheme('Light');
    } else {
      setTheme('Dark');
    }
  }, [theme.name, setTheme]);
  return <></>;
};